import { render, staticRenderFns } from "./sso-oidc.vue?vue&type=template&id=3b6ee6e8&"
import script from "./sso-oidc.vue?vue&type=script&lang=js&"
export * from "./sso-oidc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports